import React from 'react'
import styles from '../styles/InstantReview.module.scss'
import client from '../apollo/apollo-client'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { IMG_URL } from '../apollo/client-url'
import cn from 'classnames'
import VeryUnhappyIcon from '../public/very_unhappy.svg'
import UnhappyIcon from '../public/unhappy.svg'
import NeutralIcon from '../public/neutral.svg'
import HappyIcon from '../public/happy.svg'
import VeryHappyIcon from '../public/very_happy.svg'
import { FACEBOOK_URL, INSTAGRAM_URL, LINKEDIN_URL } from "../components/constants";
import { INDEX_PAGE_QUERY } from "../apollo/query/index_page_query";
import * as Sentry from "@sentry/nextjs";
import Rewards from "../components/Rewards/Rewards";
import rewardsData from "../public/files/rewards.json";
import rewardsClient from "../apollo/rewards-apollo-client";
import {REWARDS_QUERY} from "../apollo/query/businesses_rewards_query";


export async function getServerSideProps (context) {
  try {
    const { data, error: internalRewardsError } = await client.query({
      query: INDEX_PAGE_QUERY,
      variables: {
        where: {
          pageSlug: context.resolvedUrl
        }
      },
      fetchPolicy: 'no-cache'
    })

    const allFeaturedRewards = data?.allFeaturedRewards
    const randomNum = Math.floor(Math.random() * (allFeaturedRewards.length - 1))
    const randomBusinessId = allFeaturedRewards?.[randomNum]

    const firstQr = data?.allMainPageQrBusinesses?.[0]?.businessId || randomBusinessId?.businessId

    const { data: reward, error } = await rewardsClient.query({
      query: REWARDS_QUERY,
      variables: {
        id1: +data?.allMainPageQrBusinesses?.[0]?.businessId || +firstQr,
        id2: +data?.allMainPageQrBusinesses?.[1]?.businessId || +firstQr,
        id3: +data?.allMainPageQrBusinesses?.[2]?.businessId || firstQr,
        id4: +data?.allMainPageQrBusinesses?.[3]?.businessId || firstQr,
        id: +randomBusinessId?.businessId,
      },
      fetchPolicy: 'no-cache'
    })

    return { props: {
      rewards: reward || [],
      internalRewards: allFeaturedRewards,
      featuredBusiness: data.allFeaturedBusinesses,
      allMetaTag: data.allMetaTags,
    }};
  }  catch (error) {
    Sentry.captureException(error)
    return { props: {
        rewards: [],
        internalRewards: [],
        featuredBusiness: [],
        allMetaTag: [],
    }};
  }
}

function InstantReview (props) {
  const metaTag = props.allMetaTag?.[0]

  const internalRewardsData = [
    {
      "businessId": 141,
      "id": "1"
    }
  ]

  return (
    <div>
      <Head>
        <title>Instant Reviews - yesloyal</title>

        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <link rel="stylesheet" href="static/css/main.css" />

        <script src="static/js/main.js" defer></script>

        <link href="https://fonts.googleapis.com/css?family=Work+Sans:400,500,700&display=swap" rel="stylesheet"/>
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />

        {metaTag?.title && <meta name="title" content={metaTag?.title} />}
        {metaTag?.title &&  <meta property="og:title" content={metaTag?.title} />}
        {metaTag?.title && <meta property="twitter:title" content={metaTag?.title} />}

        {metaTag?.description && <meta name="description" content={metaTag?.description} />}
        {metaTag?.description &&  <meta property="og:description" content={metaTag?.description} />}
        {metaTag?.description && <meta property="twitter:description" content={metaTag?.description} />}

        {metaTag?.ogType && <meta property="og:type" content={metaTag?.ogType} />}

        {metaTag?.twitterCard && <meta property="twitter:card" content={metaTag?.twitterCard} />}

        {metaTag?.imagePreview?.publicUrl && <meta property="og:image" content={`${IMG_URL}${metaTag.imagePreview.publicUrl}`} />}
      </Head>

      <main>
        <section className={cn('main_banner')}>
          <header className={cn('header', styles.content_max_width, styles.content_header, styles.content_header_padding)}>
            <a href="/">
              <img src="/logo.png" alt="yesloyal" height='52'/>
            </a>
          </header>

          <div className={cn('content', styles.content_max_width, styles.content_header_padding)}>
            <div className={cn('banner_title', styles.banner_title)}>
              <h1 className="main_banner__heads">
                Instant <br/>
                Reviews <br/>
                Platform
              </h1>

              <p className="main_banner__description">
                Customers trust online reviews as much as
                personal recommendations, with most not using
                businesses with less than 4-star ratings.
              </p>

              <p className="main_banner__description">
                Instants reviews is an easy way to improve your Google Ratings.
              </p>

              <div className={styles.action_btn}>
                <a href='https://www.yesloyal.com/instant-reviews-pricing' target='_blank'
                   className={styles.action_btn_trial}
                >
                  START A FREE TRIAl
                </a>
                <a href='https://tidycal.com/yesloyal' target='_blank'
                   className={styles.action_btn_demo}
                >
                  BOOK A DEMO
                </a>
              </div>
            </div>

            <div className={styles.review_img_container}>
              <img src="/very_happy_review_screen.png" alt="Very happy mood screen" className={styles.review_happy_img} />
              <img src="/thank_you_review_step_2.png" alt="Thank you step" className={styles.review_thank_you_img}/>
              <img src="/google_review_screen.png" alt="Google review screen" className={styles.review_google_img}/>
            </div>

            <div className={cn('banner_social_button', styles.banner_social_button)}>
              <a className="footer_link-social" href={INSTAGRAM_URL}>
                <img src="/inst.svg" alt=""/>
              </a>
              {/*<a className="footer_link-social" href="#">*/}
              {/*  <img src="/twitter.svg" alt=""/>*/}
              {/*</a>*/}
              <a className="footer_link-social" href={LINKEDIN_URL}>
                <img src="/linkedin.svg" alt=""/>
              </a>
              <a className="footer_link-social" href={FACEBOOK_URL}>
                <img src="/facebook.svg" alt=""/>
              </a>
            </div>
          </div>

          <div className={styles.review_img_container_mobile}>
            <img src="/review_screen_mobile_group.png" alt="Screen mobile group" height='236' />
          </div>
        </section>

        <section className={styles.benefits_container}>
          <div className={cn(styles.benefits_wrapper, styles.content_max_width)}>
            <div className={styles.benefits_item}>
              <h2 className={styles.benefits_title}>Your Benefits</h2>

              <ul className={styles.benefits_list}>
                <li>
                  Win customers with more 5 star reviews.
                </li>
                <li>
                  Prevent negative reviews which impact your overall rating and reputation.
                </li>
                <li>
                  Get instant feedback so you can immediately resolve customer concerns.
                </li>
              </ul>
            </div>

            <div className={styles.benefits_item}>
              <h2 className={styles.benefits_title}>Customer benefits</h2>

              <ul className={styles.benefits_list}>
                <li>
                  No app download required.
                </li>
                <li>
                  Feedback goes directly to the Business owner.
                </li>
                <li>
                  Can request response from business if desired.
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className={styles.you_get}>
          <div className={cn(styles.you_get_wrapper, styles.content_max_width)}>
            <div className={styles.you_get_description_container}>
              <h2 className={styles.benefits_title}>You get:</h2>

              <ul className={styles.you_get_description}>
                <li>
                  Your own unique Instant Review QR code that you can use anywhere!
                  In stores, on your packaging, on your receipts, and more!
                </li>
                <li>
                  Print-ready PDF files for posters and stickers that you
                  can self-print or get us to produce! We know you’ll love them!
                </li>
                <li>
                  A digital link which can be used on any messaging platform
                  (SMS, email, WhatsApp, etc) to increase your volume of feedback and reviews!
                </li>
              </ul>
            </div>
            <div className={styles.you_get_qr}>
              <img src="/instant_review_you_get_add.png" alt="How did we me you feel today?"/>
            </div>
            
          </div>
        </section>

        <section>
          <div className={cn(styles.you_get_wrapper, styles.content_max_width, styles.you_get_wrapper_padding)}>
            <div className={styles.you_get_description_container}>
              <h2 className={styles.benefits_title}>How it works:</h2>

              <ul className={cn(styles.you_get_description, styles.you_get_description_margin)}>
                <li>
                  Customers scan your Instant Review QR code or click on the
                  digital link and our platform will help protect your business and get you Google Reviews!
                </li>
                <li>
                  We guide happy customers towards giving you a Google Review
                </li>
                <li>
                  We make sure to send unhappy customers and their complaints
                  directly to your email inbox so they won’t hurt your online reputation.
                </li>
              </ul>
            </div>
            <div className={styles.how_it_works_img}>
              <img src="/instant_review_how_it_works.png" alt="How it works"/>
            </div>

          </div>
        </section>

        <section className={styles.mood_container}>
          <div className={styles.content_max_width}>
            <div className={cn(styles.mood_icons, styles.mood_icons_hide)}>
              <div className={styles.mood_icons_item}>
                <span className={styles.mood_icons_happy}>
                  <HappyIcon/>
                </span>
                <span className={styles.mood_icons_very_happy}>
                  <VeryHappyIcon/>
                </span>
              </div>

              <div>
                <span className={styles.mood_icons_very_unhappy}>
                  <VeryUnhappyIcon/>
                </span>
                <span className={styles.mood_icons_unhappy}>
                  <UnhappyIcon/>
                </span>
                <span className={styles.mood_icons_neutral}>
                  <NeutralIcon/>
                </span>
              </div>
            </div>

            <div className={styles.mood_chooses}>
              <ul>
                <li className={styles.mood_description}>
                  Happy customers are proactively asked for a Google Review.
                </li>

                <li className={styles.mood_description}>
                  Unhappy customer feedback goes through the platform which
                  reduces negative reviews and harmful comments on Social Media.
                </li>
              </ul>
            </div>

            <div className={styles.mood_image}>
              <img src="/instant_review_mood_step.png" alt="Instant review mood step"/>
            </div>

            <div className={cn(styles.mood_description, styles.mood_review)}>
              Compliments or concerns are captured.
              Both are very helpful to take action and boost your business!
            </div>

            <div className={styles.mood_mobile}>
              <h3 className={styles.mood_title_mobile}>Customer chooses how they feel</h3>

              <div className={cn(styles.mood_icons_item, styles.mood_icons_item_mobile)}>
                <span className={styles.mood_icons_happy}>
                  <HappyIcon/>
                </span>
                <span className={styles.mood_icons_very_happy}>
                  <VeryHappyIcon/>
                </span>
              </div>

              <ul>
                <li className={styles.mood_description}>
                  Happy customers are proactively asked for a Google Review.
                </li>
              </ul>

              <div className={cn(styles.mood_icons_item, styles.mood_icons_item_mobile)}>
                <span className={styles.mood_icons_very_unhappy}>
                  <VeryUnhappyIcon/>
                </span>
                <span className={styles.mood_icons_unhappy}>
                  <UnhappyIcon/>
                </span>
                <span className={styles.mood_icons_neutral}>
                  <NeutralIcon/>
                </span>
              </div>

              <ul>
                <li className={styles.mood_description}>
                  Unhappy customer feedback goes through the platform which
                  reduces negative reviews and harmful comments on Social Media.
                </li>
              </ul>

              <h3 className={cn(styles.mood_title_mobile, styles.mood_title_mobile_margin)}>They share their thoughts</h3>

              <div className={styles.mood_description}>
                Compliments or concerns are captured.
                Both are very helpful to take action and boost your business!
              </div>

            </div>
          </div>
        </section>

        <section className={styles.happy_step_container}>
          <div className={cn(styles.content_max_width, styles.happy_step)}>
            <div className={cn(styles.mood_icons, styles.happy_step_header)}>
              <div className={styles.mood_icons_item}>
              <span className={styles.mood_icons_happy}>
                <HappyIcon/>
              </span>
                <span className={styles.mood_icons_very_happy}>
                <VeryHappyIcon/>
              </span>
              </div>
            </div>

            <div className={styles.happy_step_about_page}>
              <h2 className={styles.happy_step_title}>
                Very Happy <br/>
                /Happy
              </h2>

              <p className={styles.happy_step_description}>
                Happy customers are proactively asked for a Google Review
              </p>
            </div>

            <div>
              <div className={styles.happy_step_images_container}>
                <div className={styles.happy_step_image_review}>
                  <img src="/happy_give_review.png" alt="Give review step"/>
                </div>

                <div className={styles.happy_step_image_mood}>
                  <img src="/happy_step_mood.png" alt="Mood step"/>
                </div>
              </div>

              <div className={styles.happy_step_images_container_grid}>
                <div className={styles.happy_step_image_google}>
                  <img src="/google_review.png" alt="Google review"/>

                  <h3 className={styles.happy_step_image_title}>
                    Clicking on ‘GIVE REVIEW’
                  </h3>

                  <p className={styles.happy_step_image_decription}>
                    Gets your happy customers directly
                    to your Google Review page
                  </p>
                </div>

                <div className={styles.happy_step_image_thank_you}>
                  <img src="/thank_you_review_step.png" alt="Thank you review step"/>

                  <div className={styles.happy_step_image_description_wrapper}>
                    <h3 className={styles.happy_step_image_title}>
                      Clicking on ‘NOT TODAY’
                    </h3>

                    <p className={styles.happy_step_image_decription}>
                      Recognises them for giving
                      your business feedback
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className={cn(styles.unhappy_step)}>
          <div className={cn(styles.happy_step, styles.content_max_width, styles.bad_step)}>
            <div className={cn(styles.mood_icons, styles.happy_step_header)}>
              <div className={styles.mood_icons_item}>
              <span className={styles.mood_icons_very_unhappy}>
                <VeryUnhappyIcon/>
              </span>
                <span className={styles.mood_icons_unhappy}>
                <UnhappyIcon/>
              </span>
                <span className={styles.mood_icons_neutral}>
                <NeutralIcon/>
              </span>
              </div>
            </div>

            <div className={styles.happy_step_about_page}>
              <h2 className={styles.happy_step_title}>
                Very Unhappy <br/>
                /Unhappy <br/>
                /Neutral
              </h2>

              <p className={cn(styles.happy_step_description, styles.happy_step_description_hight)}>
                Unhappy customer feedback goes
                through the platform which reduces
                negative reviews and harmful
                comments on Social Media
              </p>
            </div>

            <div>
              <div className={styles.happy_step_images_container}>
                <div className={styles.unhappy_step_image_contact}>
                  <div className={styles.negative_feedback}>
                    This is a great tool to keep
                    negative feedback offline
                  </div>

                  <img src="/instant_review_contact_step.png" alt="Contact me step"/>
                </div>

                <div className={styles.unhappy_step_image_mood}>
                  <img src="/instant_review_bad_mood.png" alt="Bad mood step"/>
                </div>
              </div>

              <div className={styles.thank_you_container}>
                <div className={styles.unhappy_step_image_wii_be_in_touch}>
                  <img src="/instant_review_will_touch.png" alt="Will be in touch shortly step"/>
                </div>

                <div className={styles.unhappy_step_image_thank_you}>
                  <img src="/thank_you_review_step.png" alt="Thank you step"/>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

    </div>
  )
}

export default InstantReview